import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { buildBusinessProfileRows, buildBusinessProfilePWRows } from './buildBusinessProfile.helper';
import { CreateBusiessProfileHandler } from './types';
import { useLayout } from '../../../providers/Layout.provider';

const { Box, Button, Term, ElementContainer, TextField, Checkbox } = vp;

type BusinessProfileFormProps = {
  defaultValues: vp.IQ11BusinessProfile;
  handlers: CreateBusiessProfileHandler;
};

type FC = FunctionComponent<BusinessProfileFormProps>;

const BusinessProfileForm: FC = (props: BusinessProfileFormProps) => {
  const { defaultValues, handlers } = props;
  const { color } = useLayout();
  const BusinessProfileRow = buildBusinessProfileRows();
  const BusinessProfilePWRow = buildBusinessProfilePWRows();

  return (
    <Formik initialValues={defaultValues} onSubmit={handlers.onCreateBusinessProfile}>
      {({ touched, errors, handleChange, handleBlur, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          {BusinessProfileRow.map(({ label, id, required, preset }) => (
            <ElementContainer
              key={id}
              label={label}
              required={required}
              color="black"
              input={
                <TextField
                  name={id}
                  variant="background"
                  preset={preset}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={errors[id] && touched[id] ? errors[id] : null}
                />
              }
            />
          ))}

          <Box gap="sm" width="100%" jc="sb">
            {BusinessProfilePWRow.map(({ label, id, required, preset }) => (
              <Box key={id} flx="col" width="49%">
                <ElementContainer
                  label={label}
                  required={required}
                  color="black"
                  input={
                    <TextField
                      name={id}
                      variant="background"
                      preset={preset}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={errors[id] && touched[id] ? errors[id] : null}
                    />
                  }
                />
              </Box>
            ))}
          </Box>

          <Box pt="md" jc="fs">
            <div style={{ marginLeft: -30 }}>
              <Checkbox
                name="Business-profile-check"
                value={false}
                variant="rounded"
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </div>
            <Term
              term={
                <div>
                  By creating an account, you agreed to the <a>terms of service and conditions</a>, and{' '}
                  <a>privacy policy</a>
                </div>
              }
            />
          </Box>

          <Box mt="md" height="auto">
            <Link to={{ pathname: '/connect/bank' }} style={{ width: '100%' }}>
              <Button
                id="Business-profile"
                label="Create Profile"
                type="submit"
                background={color}
                textColor={vp.getContrastColor(color)}
                width="100%"
                size="xlg"
                round
                bold
                noShadow
                textSize={1}
              />
            </Link>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default BusinessProfileForm;
